import * as i0 from "@angular/core";
/** API Configure for UAT or Live  */
var config = {
    UATBaseURL: "https://uat-pwa.choicetechlab.com/api",
    UATEsignURL: "https://uat-pwa.choicetechlab.com",
    UATJFURL: "https://neurondevapi.choicetechlab.com/",
    UATMFURL: "https://uatapi.choicebroking.in/api/mf/",
    UATKYCBaseURL: "https://kyc-onboadingapi.choicetechlab.com/kycapi/",
    UATJiffyMiddlewareURL: "https://uatapi.choicebroking.in/api/middleware2/",
    UATSSOApiURL: "https://sso-api.choicetechlab.com/",
    /** for live pointed api */
    //  LiveBaseURL: "https://accounts.choiceindia.com/api",
    /**broking pointed  */
    // LiveBaseURL: "https://accounts.choicebroking.in/api",
    // LiveBaseURL: "http://20.1.50.217:8080/onBoardCore",
    /** while deploying production use this */
    LiveBaseURL: "https://accounts.choiceindia.com/api",
    // LiveBaseURL: "/api",
    LiveEsignURL: "https://accounts.choiceindia.com/",
    LiveJFURL: "https://neuronapi.choicetechlab.com/",
    LiveMFURL: "https://api.choiceindia.com/api/mf/",
    LiveAlphabeeEsignURL: "https://alphabee.choicebroking.in/",
    LiveKYCBaseURL: "https://accounts.choiceindia.com/kycapi/",
    // LiveKYCBaseURL: "https://accounts.choicebroking.in/kycapi/",
    LiveJiffyMiddlewareURL: "https://finx.choiceindia.com/api/middleware2/",
    LiveSSOApiURL: "https://sso-api.choiceindia.com/",
    UATPennyDropBaseURL: "https://kyc-onboadingapi.choicetechlab.com/kycapi/",
    LivePennyDropBaseURL: "https://accounts.choiceindia.com/kycapi/",
    LiveModificationURL: "https://accounts.choiceindia.com/",
    UATModificationURL: "https://accounts.choiceindia.com/"
};
/** Service Injectable */
var APIURLs = /** @class */ (function () {
    /** Initializes the component with default values. */
    function APIURLs() {
        /** environment */
        this.environment = "Live";
        /** version */
        this.version = "v1.12.6.4";
        /**modification URL */
        this.modificationURL = "";
        /** server URL  */
        this.serverURL = "";
        /** esign Base URL */
        this.esignBaseURL = "";
        /** penny Esign URL*/
        this.pennyEsignURL = "";
        /** KYC Base URL */
        this.KYCBaseURL = "";
        /** Jiffy Middleware URL */
        this.JiffyMiddlewareURL = "";
        /** SSO Api URL */
        this.SSOApiURL = "";
        /** Penny Drop Base URL */
        this.PennyDropBaseURL = "";
        /** encrypt URL */
        this.encryptURL = "/utility/list/encrypt";
        /** decrypt URL */
        this.decryptURL = "/utility/list/decrypt";
        /** checkExistence URL */
        this.checkExistenceURL = "/onboard/checkExistence";
        /** invDetails URL */
        this.invDetailsURL = "/onboard/getInvestorDetails";
        /** register Investor URL */
        this.registerInvestorURL = "/onboard/registerInvesticaUser?forceUpdate=$forceUpdate";
        /** PAN Details URL */
        this.pANDetailsURL = "kra/get-pan-details";
        /** pan Details URL Version 2 */
        this.panDetailsURLV2 = "kra/get-pan-details/v2";
        /** lead City List URL */
        this.leadCityListURL = "/onboard/getLeadCities";
        /** update Investor Details URL */
        this.updateInvDetailsURL = "/onboard/updateClientDetails";
        /** bank List URL */
        this.bankListURL = "/onboard/getBankList";
        /** branch List URL */
        this.branchListURL = "/onboard/getBranchByBank/$bank";
        /** bank Details URL */
        this.bankDetailsURL = "fetch-ifsc-detail/$ifsc";
        /** state List URL */
        this.stateListURL = "/onboard/getState";
        /** iPV OTP URL */
        this.iPVOTPURL = "/onboard/getIPVOTP";
        /** upload IPV URL */
        this.uploadIPVURL = "/onboard/uploadIPV?newFileName=$newFileName";
        /** upload Document URL */
        this.uploadDocURL = "/upload?newFileName=$newFileName&documentOf=$documentOf";
        /** upload Documents URL */
        this.uploadDocsURL = "/onboard/multiUpload?newFileNames=$newFileNames&documentsOf=$documentsOf";
        /** upload AOF Documents URL */
        this.uploadAOFDocsURL = "/onboard/uploadAofDocument";
        /** onboard Complete URL*/
        this.onboardCompleteURL = "/onboard/onBoardComplete/$isEsignFlag";
        /** education List URL */
        this.educationListURL = "/onboard/getEducationList";
        /** occupation List URL */
        this.occupationListURL = "/onboard/getOccupationList";
        /** income Slab List URL */
        this.incomeSlabListURL = "/onboard/getIncomeSlabList";
        /** update Screen URL */
        this.updateScreenURL = "/onboard/addOnBoardingTracker";
        /** investorById URL */
        this.investorByIdURL = "/investor/getById?id=$id";
        /** screen List URL */
        this.screenListURL = "/onboard/getScreenList";
        /**  country List URL*/
        this.countryListURL = "/onboard/getCountryList";
        /** document Base URL */
        this.docBaseURL = "/files/$investorId/$fileName";
        /** delete Nominee URL */
        this.deleteNomineeURL = "/onboard/deleteNomineeByInvestorId?id=$id";
        /** delete segments URL */
        this.deleteSegmentsURL = "/onboard/deleteInvestorSegmentByInvestorId?id=$id";
        /** generate Forms URL */
        this.generateFormsURL = "/onboard/generateforms?isESignFlag=$isEsignFlag";
        /**  bank Modification Request List URL*/
        this.bankModificationRequestListURL = "/investorBankDetailsModified/getByInvestorIdAndApprovedFlag?investorId=$investorId&approvedFlag=$approvedFlag";
        /** segment Modification Request List URL  */
        this.segmentModificationRequestListURL = "/modification/getByApprovedFlag?type=segment&isApprovedFlag=N&investorId=$investorId";
        /** address Modification Request List URL */
        this.addressModificationRequestListURL = "/modification/getByApprovedFlag?type=address&isApprovedFlag=N&investorId=$investorId";
        /** nomiee Modification Request List URL */
        this.nomieeModificationRequestListURL = "/modification/getByApprovedFlag?type=nomineeModification&isApprovedFlag=N&investorId=$investorId";
        /** esign URL */
        this.esignURL = "/assets/esign.html?id=$id";
        /** support MF URL  */
        this.supportMFURL = "static/SendEmail_V2";
        /** support JF URL */
        this.supportJFURL = "contact/support";
        /** porting URL */
        this.portingURL = "/onboard/port";
        /** porting URL  */
        this.sendOTPURL = "/otp/send?panNum=$panNum";
        /** send OTP URL */
        this.migrateDocURL = "/onboard/investorMigratingImage?sourceInvestorId=$sourceInvestor&destInvestorId=$destInvestor";
        /** delete Investor URL  */
        this.deleteInvestorURL = "/onboard/deleteById?id=$id";
        /** delete ClientId URL */
        this.deleteClientIdURL = "/investor/deleteByClientId?clientId=$clientId";
        /** validate OTP URL */
        this.validateOTPURL = "/otp/verify?otp=$otp&newInvestorId=$newInvestorId&panNum=$panNum";
        /** recover Account URL */
        this.recoverAccountURL = "/onboard/investicaRecover?panStr=$panStr&mobileNumber=$mobileNumber";
        /** generated Forms URL */
        this.generatedFormsURL = "/forms/$formName";
        /** investor ByLeadId URL */
        this.investorByLeadIdURL = "/investorDetails/getByLeadId?leadId=$leadId";
        /** investor ByPanClient URL */
        this.investorByPanClientURL = "/neuron/getByPanOrClientId/$panOrClient/$businessUnit";
        /** send Modify OTP URL */
        this.sendModifyOTPURL = "/segmentActivation/sendOTP?ssoSubjectId=$subjectId&mobileNum=$mobileNum&emailId=$emailId&purpose=$purpose";
        // private sendContactVerifyOTPUrl: string = "unified/send-otp";
        /** verify Modify OTP URL */
        this.verifyModifyOTPURL = "/segmentActivation/verifyOTP?id=$investorId&otp=$otp&purpose=$purpose";
        /** check Mobile Number URL  */
        this.checkMobileNumberURL = "/modification/checkMobileNum?mobileNum=$mobileNum";
        /** upload Modification File URL  */
        this.uploadModificationFileURL = "/modification/upload?newFileName=$newFileName&documentOf=$documentOf";
        /** submit Modification Request URL  */
        this.submitModificationRequestURL = "/modification/modifyClientDetails";
        /** generate Modification Form URL */
        this.generateModificationFormURL = "/modification/modifyFormGenerate?isEmail=$isEmail";
        /** send Modification Email URL */
        this.sendModificationEmailURL = "/modification/modifyEmailGenerate?formName=$formName";
        /** modify Esign URL */
        this.modifyEsignURL = "/esign/kycesignRequest?id=$id&form=$form";
        /** emudhra Esign URL */
        this.emudhraEsignURL = "/api/request?id=$id";
        /** brokerage Data URL */
        this.brokerageDataURL = "/json/brokerage.json?q=$q";
        /** lang Data URL */
        this.langDataURL = "/json/$lang.json?q=$q";
        /** send Onboard OTP URL */
        this.sendOnboardOTPURL = 
        // "/onboard/sendOTPNewOnboard?mobileNum=$mobileNum&emailId=$email";
        "unified/send-otp";
        /** verify Onboard OTP URL */
        this.verifyOnboardOTPURL = 
        // "/onboard/verifyOTPNewOnboard?otp=$otp&id=$id";
        "unified/verify-otp";
        /** account closure details api */
        this.accountClosureDetails = 'account-closure/details';
        /** aadhar KYC URL */
        this.aadharKYCURL = "/nsdlekyc/startEkycRequest?pan=$pan&id=$id";
        /** brokerage By ReferCode URL */
        this.brokerageByReferCodeURL = "/brokerage/findBrokerageByReferredId?id=$id";
        // private pennyDropURL: string = '/pennyDrop/validateAdd?account=$account&ifsc=$ifsc&investorId=$id';
        /** Penny Drop */
        this.pennyDropURL = "penny-drop";
        /** recover Client URL */
        this.recoverClientURL = "/onboard/recoverClientIdByPAN/$pan";
        /** respond Issue URL*/
        this.respondIssueURL = "/raiseIssue/respondIssue/$respondedBy";
        /**  location URL*/
        this.locationURL = "https://maps.googleapis.com/maps/api/geocode/json?latlng=$latlng&result_type=sublocality_level_1&key=AIzaSyBxviqIPl6cmRLtkyoVlGMdo3-zq_gJ7N0";
        /** auth header */
        this.authHeader = { MF: "aW52ZXN0aWNh", JF: "amlmZnlBcHA=" };
        /** bu Brokerage Data URL */
        this.buBrokerageDataURL = "https://ctl-ob-brokerage-$env.s3.ap-south-1.amazonaws.com/AlphabeeBrokerage.json";
        /** update Duplicate Lid Against Pan URL */
        this.updateDuplicateLidAgainstPanURL = "/onboard/updateDuplicateLeadAgainstPan";
        /** referral Details URL */
        this.referralDetailsURL = "/onboard/getReferralDetails?referredId=$id";
        /** bank Bazaar Update DetailsURL */
        this.bankBazaarUpdateDetailsURL = "/onboard/bbUpdateClientDetails";
        /** upload Bank Bazaar Docs URL */
        this.uploadBankBazaarDocsURL = "/onboard/multiUpload";
        /** delete New Lead Against Pan URL */
        this.deleteNewLeadAgainstPanURL = "/leadMapping/changeLeadStatus";
        /** digio Doc Upload URL */
        this.digioDocUploadURL = "/onboard/uploadDocumentToDigio?formName=$formName";
        /** digio Doc Download URL */
        this.digioDocDownloadURL = "/onboard/downloadDigioDocument?formName=$formName&panNum=$pan&id=$docId";
        /** check Unique Mobile or Email URL*/
        this.checkUniqueMobileEmailURL = "/onboard/checkUnique";
        /** IPV Sms URL */
        this.IPVSmsURL = "/onboard/sendIPVSMS";
        /** generate KYC URL */
        this.generateKYCURL = "generate-kyc-request";
        /** save KYC URL */
        this.saveKYCURL = "save-kyc-details";
        /** send Respond OTP URL */
        this.sendRespondOTPURL = "/raiseIssue/sendOTP";
        /** verifyRespondOTPURL */
        this.verifyRespondOTPURL = "/raiseIssue/verifyOTP?otp=$otp";
        /** referral Code Validation URL */
        this.referralCodeValidationURL = "/utility/validateReferral/$referralcode";
        /** pan Validate KYC URL*/
        this.panValidateKYCURL = "pan-validate";
        /** education List V2 URL*/
        this.educationListV2URL = "education/list";
        /** check Unique Mobile or Email Offline URL */
        this.checkUniqueMobileEmailOfflineURL = "/onboard/checkUniqueOffline";
        /** Client Dormant */
        this.isClientDormantURL = "CheckIsDormant";
        /** send OTP V2 URL */
        this.sendOTPV2URL = "modification/send-otp";
        /** verify OTP V2 URL */
        this.verifyOTPV2URL = "modification/verify-otp";
        /** send OTP AC URL */
        this.sendOTPACURL = "account-closure/send-otp";
        /** verify OTP ACL */
        this.verifyOTPACURL = "account-closure/verify-otp";
        /** Account closure  */
        this.sendACEmailURL = "/account-closure/send-mail";
        /** masking URL */
        this.maskingURL = "aadhar-masking";
        /**optimized state list url */
        this.stateListURLV2 = "state/list";
        /**optimized city list url */
        this.cityListURLV2 = "city/list?cityName=$cityname";
        /** modify Selfie*/
        this.modifySelfie = "selfie-upload";
        /**endpoint url for generate access token api */
        this.accessToken = "access/token";
        /**validation api */
        this.validationURL = "user-validation";
        /** signature ocr */
        this.signatureOCR = 'upload-sign';
        /**secure document download url */
        this.fileDownloadURL = "preview/document";
        /**dp preference url */
        this.updateDPPreference = "update-details";
        /** DP Preference*/
        this.getDPPreference = "investor-details/$investorId";
        /** get all banks with logo */
        this.getAllBanks = "bank/list";
        /** digio events log api url */
        this.digioEventsURL = 'digio-event-logs';
        /**api url for genereate short link for segment and service modificaton */
        this.generateShortLink = "modification/api/generate-link";
        /** sso email validation api  */
        this.emailValidation = "validate-email";
        /** Account aggregator generate request */
        this.generateUrl = "account-aggregator/generate-request";
        /**Account Closure Store Details */
        this.storeDetails = "account-closure/store";
        this.setServerURL();
        this.setEsignBaseURL();
        this.setKYCBaseURL();
        this.setJiffyMiddlewareBaseURL();
        this.setSSOApiURL();
        this.setPennyDropBaseURL();
        this.setModificationURL();
    }
    /**
     * environment setup
     */
    APIURLs.prototype.setServerURL = function () {
        this.serverURL = config[this.environment + "BaseURL"];
    };
    /**
     * environment setup
     */
    APIURLs.prototype.setEsignBaseURL = function () {
        this.esignBaseURL =
            location.hostname.indexOf("localhost") == -1
                ? location.origin
                : this.serverURL;
        this.pennyEsignURL = config[this.environment + "EsignURL"];
        // (location.hostname.indexOf('accounts.') > -1 ? config[this.environment + 'EsignURL'] : location.hostname.indexOf('alphabee.') > -1) ? config[this.environment + 'AlphabeeEsignURL'] : config['UATEsignURL'];
    };
    /**
     * environment setup
     */
    APIURLs.prototype.setKYCBaseURL = function () {
        this.KYCBaseURL = config[this.environment + "KYCBaseURL"];
    };
    /**
   * Sets the base URL for Jiffy Middleware depending on the current environment.
   * This method retrieves the middleware URL from the configuration file based on the current environment
   * and assigns it to the `JiffyMiddlewareURL` property.
   */
    APIURLs.prototype.setJiffyMiddlewareBaseURL = function () {
        /** Sets the Jiffy Middleware URL for the current environment */
        this.JiffyMiddlewareURL = config[this.environment + "JiffyMiddlewareURL"];
    };
    /**
     * environment setup
     */
    APIURLs.prototype.setSSOApiURL = function () {
        this.SSOApiURL = config[this.environment + "SSOApiURL"];
    };
    /**
   * environment setup
   */
    APIURLs.prototype.setPennyDropBaseURL = function () {
        this.PennyDropBaseURL = config[this.environment + "PennyDropBaseURL"];
    };
    /**
   * environment setup
   */
    APIURLs.prototype.setModificationURL = function () {
        this.modificationURL = config[this.environment + "ModificationURL"];
    };
    /**
     * Get Version setup
     * @returns Version setup
     */
    APIURLs.prototype.getVersion = function () {
        return this.version;
    };
    /**
     * Get Decrypt URL
     * @returns Respective API url
     */
    APIURLs.prototype.getDecryptURL = function () {
        return this.serverURL + this.decryptURL;
    };
    /**
     * Get Encrypt URL
     * @returns Respective API url
     */
    APIURLs.prototype.getEncryptURL = function () {
        return this.serverURL + this.encryptURL;
    };
    /**
     * Get CheckExistence URL
     * @returns Respective API url
     */
    APIURLs.prototype.getCheckExistenceURL = function () {
        return this.serverURL + this.checkExistenceURL;
    };
    /**
     * Get Investor Details URL
     * @returns Respective API url
     */
    APIURLs.prototype.getInvDetailsURL = function () {
        return this.serverURL + this.invDetailsURL;
    };
    /**
     * Get Register Investor URL
     * @param isForceProcess
     * @returns Respective API url
     */
    APIURLs.prototype.getRegisterInvestorURL = function (isForceProcess) {
        return (this.serverURL +
            this.registerInvestorURL.replace("$forceUpdate", isForceProcess || "N"));
    };
    /**
     * Get PAN Details URL
     * @returns Respective API url
     */
    APIURLs.prototype.getPANDetailsURL = function () {
        return this.KYCBaseURL + this.panDetailsURLV2;
        // return "https://accounts.choicebroking.in/kycapi/" + this.panDetailsURLV2
    };
    /**
     * Get Lead City List URL
     * @returns Respective API url
     */
    APIURLs.prototype.getLeadCityListURL = function () {
        return this.serverURL + this.leadCityListURL;
    };
    /**
     * Get Update InvDetails URL
     * @returns Respective API url
     */
    APIURLs.prototype.getUpdateInvDetailsURL = function () {
        return this.serverURL + this.updateInvDetailsURL;
    };
    /**
     * Getting Bank List URL
     * @returns Respective API url
     */
    APIURLs.prototype.getBankListURL = function () {
        return this.serverURL + this.bankListURL;
    };
    /**
     * Get Bank Details URL
     * @param ifsc Passing ifsc
     * @returns Respective API url
     */
    APIURLs.prototype.getBankDetailsURL = function (ifsc) {
        return this.KYCBaseURL + this.bankDetailsURL.replace("$ifsc", ifsc);
    };
    /**
     * Get Bank Branch List URL
     * @param bank Passing bank name
     * @returns Respective API url
     */
    APIURLs.prototype.getBranchListURL = function (bank) {
        return this.serverURL + this.branchListURL.replace("$bank", bank);
    };
    /**
     * Get State List URL
     * @returns Respective API url
     */
    APIURLs.prototype.getStateListURL = function () {
        return this.serverURL + this.stateListURL;
    };
    /**
     * Get Education List URL
     * @returns Respective API url
     */
    APIURLs.prototype.getEducationListURL = function () {
        return this.serverURL + this.educationListURL;
    };
    /**
     * Get OccupationList URL
     * @returns Respective API url
     */
    APIURLs.prototype.getOccupationListURL = function () {
        return this.serverURL + this.occupationListURL;
    };
    /**
     * Get Income SlabList URL
     * @returns Respective API url
     */
    APIURLs.prototype.getIncomeSlabListURL = function () {
        return this.serverURL + this.incomeSlabListURL;
    };
    /**
     * Get Screen List URL
     * @returns Respective API url
     */
    APIURLs.prototype.getScreenListURL = function () {
        return this.serverURL + this.screenListURL;
    };
    /**
     * Get Update Screen URL
     * @returns Respective API url
     */
    APIURLs.prototype.getUpdateScreenURL = function () {
        return this.serverURL + this.updateScreenURL;
    };
    /**
     * Get Country List URL
     * @returns Respective API url
     */
    APIURLs.prototype.getCountryListURL = function () {
        return this.serverURL + this.countryListURL;
    };
    /**
     * Get Upload IPV URL
     * @param fileName Respective API url
     * @returns Respective API url
     */
    APIURLs.prototype.getUploadIPVURL = function (fileName) {
        return this.serverURL + this.uploadIPVURL.replace("$newFileName", fileName);
    };
    /**
     * Get IPV OTP URL
     * @returns Respective API url
     */
    APIURLs.prototype.getIPVOTPURL = function () {
        return this.serverURL + this.iPVOTPURL;
    };
    /**
     * Get Upload Document URL
     * @param fileName passing file name
     * @param documentType Passing Document Type
     * @returns Respective API url
     */
    APIURLs.prototype.getUploadDocURL = function (fileName, documentType) {
        return (this.serverURL +
            this.uploadDocURL
                .replace("$newFileName", fileName)
                .replace("$documentOf", documentType));
    };
    /**
     * Get Upload Documents URL
     * @param fileNames Passing fileNames
     * @param documentTypes Passing  documentTypes
     * @returns Respective API url
     */
    APIURLs.prototype.getUploadDocsURL = function (fileNames, documentTypes) {
        return (this.serverURL +
            this.uploadDocsURL
                .replace("$newFileNames", fileNames)
                .replace("$documentsOf", documentTypes));
    };
    /**
     * Get Upload Aof URL
     * @returns Respective API url
     */
    APIURLs.prototype.getUploadAofURL = function () {
        return this.serverURL + this.uploadAOFDocsURL;
    };
    /**
     * Get Onboard Complete URL
     * @param isEsignFlag Passing isEsignFlag
     * @returns Respective API url
     */
    APIURLs.prototype.getOnboardCompleteURL = function (isEsignFlag) {
        return (this.serverURL +
            this.onboardCompleteURL.replace("$isEsignFlag", isEsignFlag || "N"));
        // return 'https://accounts.choicebroking.in/api' + this.onboardCompleteURL.replace('$isEsignFlag', isEsignFlag || 'N');
    };
    /**
     * Get Delete Nominee URL
     * @param investorId Passing investorId
     * @returns Respective API url
     */
    APIURLs.prototype.getDeleteNomineeURL = function (investorId) {
        return this.serverURL + this.deleteNomineeURL.replace("$id", investorId);
    };
    /**
     * Get Delete Segment URL
     * @param investorId Pass investorId
     * @returns Respective API url
     */
    APIURLs.prototype.getDeleteSegmentURL = function (investorId) {
        return this.serverURL + this.deleteSegmentsURL.replace("$id", investorId);
    };
    /**
     * Get Generate Forms URL
     * @param isEsignFlag Passing isEsignFlag
     * @returns Respective API url
     */
    APIURLs.prototype.getGenerateFormsURL = function (isEsignFlag) {
        return (this.serverURL +
            this.generateFormsURL.replace("$isEsignFlag", isEsignFlag || "N"));
    };
    /** Account Closure Store Details */
    APIURLs.prototype.getstoreDetailsURL = function () {
        return this.KYCBaseURL + this.storeDetails;
    };
    /**
     * Get Esign URL
     * @param investorId Passing investorId
     * @returns Respective API url
     */
    APIURLs.prototype.getEsignURL = function (investorId) {
        return (this.esignBaseURL.replace("/api", "") +
            this.esignURL.replace("$id", investorId));
    };
    /**
     * Get Support URL
     * @param businessUnit Pass business Unit
     * @returns Respective API url
     */
    APIURLs.prototype.getSupportURL = function (businessUnit) {
        businessUnit = businessUnit == "MFJF" ? "JF" : businessUnit || "MF";
        var baseURL = location.hostname.indexOf("accounts.") > -1
            ? config[this.environment + (businessUnit + "URL")]
            : config["UAT" + (businessUnit + "URL")];
        return baseURL + this["support" + businessUnit + "URL"];
    };
    /**
     * Get Porting URL
     * @returns Respective API url
     */
    APIURLs.prototype.getPortingURL = function () {
        return this.serverURL + this.portingURL;
    };
    /**
     * Get Recover Account URL
     * @param pan Passing Pan Number
     * @param mobileNumber Passing Mobile Number
     * @returns Respective API url
     */
    APIURLs.prototype.getRecoverAccountURL = function (pan, mobileNumber) {
        return (this.serverURL +
            this.recoverAccountURL
                .replace("$panStr", pan)
                .replace("$mobileNumber", mobileNumber));
    };
    /**
     * Get Validate OTP URL
     * @param panNum Passing Pan number
     * @returns Respective API url
     */
    APIURLs.prototype.getSendOTPURL = function (panNum) {
        return this.serverURL + this.sendOTPURL.replace("$panNum", btoa(panNum));
    };
    /**
     * Get Validate OTP URL
     * @param otp passing otp
     * @param investorId  Passing InvestorId
     * @param panNum  Passing Pan number
     * @returns Respective API url
     */
    APIURLs.prototype.getValidateOTPURL = function (otp, investorId, panNum) {
        return (this.serverURL +
            this.validateOTPURL
                .replace("$otp", otp)
                .replace("$newInvestorId", investorId)
                .replace("$panNum", btoa(panNum)));
    };
    /**
     * Get Authorization Header
     * @param businessUnit  Passing businessUnit
     * @returns Respective API url
     */
    APIURLs.prototype.getAuthorizationHeader = function (businessUnit) {
        businessUnit = businessUnit || this.getBusinessUnit();
        return this.authHeader[businessUnit];
    };
    /**
     * Get BusinessUnit
     * @returns Respective API url
     */
    APIURLs.prototype.getBusinessUnit = function () {
        var href = location.href.toLowerCase();
        return href.indexOf("/mf/") > -1 || href.indexOf("/connect-mf/") > -1
            ? "MF"
            : href.indexOf("/trading/") > -1 ||
                href.indexOf("/connect-trading/") > -1 ||
                href.indexOf("/mf-trading/") > -1 ||
                href.indexOf("/connect-mf-trading/") > -1
                ? "JF"
                : "JF";
    };
    /**
     * Get Migrate Document URL
     * @param sourceInvestorId Passing Source InvestorId
     * @param destInvestorId Passing Dest InvestorId
     * @returns Respective API url
     */
    APIURLs.prototype.getMigrateDocURL = function (sourceInvestorId, destInvestorId) {
        return (this.serverURL +
            this.migrateDocURL
                .replace("$sourceInvestor", sourceInvestorId)
                .replace("$destInvestor", destInvestorId));
    };
    /**
     * Get Delete Investor URL
     * @param investorId passing investorId
     * @returns Respective API url
     */
    APIURLs.prototype.getDeleteInvestorURL = function (investorId) {
        return this.serverURL + this.deleteInvestorURL.replace("$id", investorId);
    };
    /**
     * Get InvestorById URL
     * @param investorId Passing investorId
     * @returns Respective API url
     */
    APIURLs.prototype.getInvestorByIdURL = function (investorId) {
        return this.serverURL + this.investorByIdURL.replace("$id", investorId);
    };
    /**
     * Get Delete ClientId URL
     * @param clientId Passing clientId
     * @returns Respective API url
     */
    APIURLs.prototype.getDeleteClientIdURL = function (clientId) {
        return (this.serverURL + this.deleteClientIdURL.replace("$clientId", clientId));
    };
    /**
     * Get Document Base URL
     * @param investorId Passing investor Id
     * @param fileName Passing file Name
     * @returns Respective API url
     */
    APIURLs.prototype.getDocBaseURL = function (investorId, fileName) {
        var normalizedFileName = fileName;
        if (fileName && fileName.indexOf("/")) {
            var fileChunks = fileName.split("/");
            normalizedFileName = fileChunks[fileChunks.length - 1];
        }
        return (this.serverURL +
            this.docBaseURL
                .replace("$investorId", investorId)
                .replace("$fileName", normalizedFileName));
    };
    /**
     * Get Generated Form URL
     * @param fileName passing file Name
     * @returns Respective API url
     */
    APIURLs.prototype.getGeneratedFormURL = function (fileName) {
        return (this.serverURL + this.generatedFormsURL.replace("$formName", fileName));
    };
    /**
     * Get Investor ByLeadId URL
     * @param leadId Passing leadId
     * @returns Respective API url
     */
    APIURLs.prototype.getInvestorByLeadIdURL = function (leadId) {
        return (this.serverURL.replace("/api", "/leadManagement") +
            this.investorByLeadIdURL.replace("$leadId", leadId));
    };
    /**
     * Get Investor By Pan URL
     * @param panOrClient Passing pan Or Client
     * @param businessUnit Passing businessUnit
     * @returns Respective API url
     */
    APIURLs.prototype.getInvestorByPanClientURL = function (panOrClient, businessUnit) {
        businessUnit = businessUnit || this.getBusinessUnit();
        return (this.serverURL +
            this.investorByPanClientURL
                .replace("$panOrClient", panOrClient)
                .replace("$businessUnit", businessUnit));
    };
    /**
     * Get Verify Modify OTP URL
     * @returns Respective API url
     */
    APIURLs.prototype.getVerifyModifyOTPURL = function () {
        return (this.KYCBaseURL +
            this.verifyOnboardOTPURL);
        // return "https://accounts.choicebroking.in/kycapi/unified/verify-otp"
    };
    /**
     * Get Send Modify OTP URL
     * @param subjectId passing subjectId
     * @param purpose passing purpose
     * @param mobileNum passing mobileNum
     * @param emailId passing emailId
     * @returns Respective API url
     */
    APIURLs.prototype.getSendModifyOTPURL = function (subjectId, purpose, mobileNum, emailId) {
        return (this.serverURL +
            this.sendModifyOTPURL
                .replace("$subjectId", subjectId)
                .replace("$purpose", purpose)
                .replace("$mobileNum", mobileNum)
                .replace("$emailId", emailId));
    };
    /**
     * Get Send Contact Verify OTP URL
     * @returns Respective API url
     */
    APIURLs.prototype.getSendContactVerifyOTPURL = function () {
        return (this.KYCBaseURL + this.sendOnboardOTPURL);
        // return 'https://accounts.choicebroking.in/kycapi/unified/send-otp'
    };
    /**
     * Get Upload Modification File URL
     * @param fileName Passing file name
     * @param documentType Passing document Type
     * @returns Respective API url
     */
    APIURLs.prototype.getUploadModificationFileURL = function (fileName, documentType) {
        return (this.serverURL +
            this.uploadModificationFileURL
                .replace("$newFileName", fileName)
                .replace("$documentOf", documentType));
    };
    /**
     * Get Check Mobile Number URL
     * @param mobileNumber Passing MobileNumber
     * @returns Respective API url
     */
    APIURLs.prototype.getCheckMobileNumberURL = function (mobileNumber) {
        return (this.serverURL +
            this.checkMobileNumberURL.replace("$mobileNum", mobileNumber));
    };
    /**
     * Get Submit Modification Request URL
     * @returns Respective API url
     */
    APIURLs.prototype.getSubmitModificationRequestURL = function () {
        return this.serverURL + this.submitModificationRequestURL;
    };
    /**
     * Get Generte Modification Form URL
     * @param isEmail
     * @returns Respective API url
     */
    APIURLs.prototype.getGenerteModificationFormURL = function (isEmail) {
        return (this.serverURL +
            this.generateModificationFormURL.replace("$isEmail", isEmail));
    };
    /**
     * get Send Modification Email URL
     * @param formName passing form value
     * @returns Respective API url
     */
    APIURLs.prototype.getSendModificationEmailURL = function (formName) {
        return (this.serverURL +
            this.sendModificationEmailURL.replace("$formName", formName));
    };
    /**
     * get Modify Esign URL
     * @param investorId passing investor Id
     * @param form passing form
     * @returns Respective API url
     */
    APIURLs.prototype.getModifyEsignURL = function (investorId, form) {
        return (this.esignBaseURL +
            this.modifyEsignURL.replace("$id", investorId).replace("$form", form));
    };
    /**
     * get Emudhra Esign URL
     * @param investorId
     * @returns Respective API url
     */
    APIURLs.prototype.getEmudhraEsignURL = function (investorId) {
        return ("https://emudhra.choicebroking.in" +
            this.emudhraEsignURL.replace("$id", investorId));
    };
    /**
     * get Bank Modification Request  List URL
     * @param investorId
     * @param approvedFlag
     * @returns Respective API url
     */
    APIURLs.prototype.getBankModificationRequestListURL = function (investorId, approvedFlag) {
        return (this.serverURL +
            this.bankModificationRequestListURL
                .replace("$investorId", investorId)
                .replace("$approvedFlag", approvedFlag || "N"));
    };
    /**
     * get Segment Modification Request List URL
     * @param investorId passing Investor Id
     * @param approvedFlag passing Approved Flag
     * @returns Respective API url
     */
    APIURLs.prototype.getSegmentModificationRequestListURL = function (investorId, approvedFlag) {
        return (this.serverURL +
            this.segmentModificationRequestListURL.replace("$investorId", investorId));
    };
    /**
     * Get Address Modification Request List URL
     * @param investorId passing investor Id
     * @param approvedFlag passing approved Flag
     * @returns Respective API url
     */
    APIURLs.prototype.getAddressModificationRequestListURL = function (investorId, approvedFlag) {
        return (this.serverURL +
            this.addressModificationRequestListURL.replace("$investorId", investorId));
    };
    /**
     * get Nominee Modification Request List URL
     * @param investorId passing  investor Id
     * @param approvedFlag passing approved Flag
     * @returns Respective API url
     */
    APIURLs.prototype.getNomineeModificationRequestListURL = function (investorId, approvedFlag) {
        return (this.serverURL +
            this.nomieeModificationRequestListURL.replace("$investorId", investorId));
    };
    /**
     * get Brokerage Data URL
     * @returns Respective API url
     */
    APIURLs.prototype.getBrokerageDataURL = function () {
        return this.brokerageDataURL.replace("$q", new Date().valueOf() + "");
    };
    /**
     * get Send Onboard OTP URL
     * @returns Respective API url
     */
    APIURLs.prototype.getSendOnboardOTPURL = function () {
        return (
        // "https://accounts.choicebroking.in/kycapi/unified/send-otp"
        this.KYCBaseURL + this.sendOnboardOTPURL);
    };
    /**
     * get Verify Onboard OTP URL
     * @returns Respective API url
     */
    APIURLs.prototype.getVerifyOnboardOTPURL = function () {
        return (
        // "https://accounts.choicebroking.in/kycapi/unified/verify-otp"
        this.KYCBaseURL + this.verifyOnboardOTPURL);
    };
    /**
     * get Aadhaar KYC URL
     * @param investorId paasing investorId
     * @param panNum passing pan Number
     * @returns Respective API url
     */
    APIURLs.prototype.getAadharKYCURL = function (investorId, panNum) {
        return (this.esignBaseURL +
            this.aadharKYCURL.replace("$id", investorId).replace("$pan", panNum));
    };
    /**
     * get Brokerage By ReferCode URL
     * @param referCode passing referCode
     * @returns Respective API url
     */
    APIURLs.prototype.getBrokerageByReferCodeURL = function (referCode) {
        return (this.serverURL + this.brokerageByReferCodeURL.replace("$id", referCode));
    };
    /**
     * get penny DropURL
     * @returns Respective API url
     */
    APIURLs.prototype.getpennyDropURL = function () {
        return this.PennyDropBaseURL + this.pennyDropURL;
    };
    /**
     * get Recover Client URL
     * @param pan Respective API url
     * @returns espective API url
     */
    APIURLs.prototype.getRecoverClientURL = function (pan) {
        return this.serverURL + this.recoverClientURL.replace("$pan", pan);
    };
    /**
     * get Respond Issue URL
     * @param respondedBy get responded value
     * @returns Respective API url
     */
    APIURLs.prototype.getRespondIssueURL = function (respondedBy) {
        return (this.serverURL + this.respondIssueURL.replace("$respondedBy", respondedBy));
    };
    /**
     * get Location URL
     * @param latlng passing language
     * @returns Respective API url
     */
    APIURLs.prototype.getLocationURL = function (latlng) {
        return this.locationURL.replace("$latlng", latlng);
    };
    /**
     *  get Lang Data URL
     * @param language  passing language
     * @returns Respective API url
     */
    APIURLs.prototype.getLangDataURL = function (language) {
        return this.langDataURL
            .replace("$lang", language)
            .replace("$q", new Date().valueOf() + "");
    };
    /**
     * get BUBrokerag eData URL
     * @returns Respective API url
     */
    APIURLs.prototype.getBUBrokerageDataURL = function () {
        var env = location.hostname.indexOf("accounts.choiceindia.com") > -1 ||
            location.hostname.indexOf("accounts.choicebroking.in") > -1 ||
            this.serverURL == "https://accounts.choiceindia.com/api" ||
            this.serverURL == "https://accounts.choicebroking.in/api"
            ? "prod"
            : "uat";
        return this.buBrokerageDataURL.replace("$env", env);
    };
    /**
     * get update Duplicate Lid Against Pan URL
     * @returns Respective API url
     */
    APIURLs.prototype.getupdateDuplicateLidAgainstPanURL = function () {
        return this.serverURL + this.updateDuplicateLidAgainstPanURL;
    };
    /**
     * get referral Details URL
     * @param id passing id
     * @returns Respective API url
     */
    APIURLs.prototype.getreferralDetailsURL = function (id) {
        return this.serverURL + this.referralDetailsURL.replace("$id", id);
    };
    /**
     * get BankBazaar Update Details URL
     * @returns Respective API url
     */
    APIURLs.prototype.getBankBazaarUpdateDetailsURL = function () {
        return this.serverURL + this.bankBazaarUpdateDetailsURL;
    };
    /**
     * get BankBazaar Upload Docs URL
     * @returns Respective API url
     */
    APIURLs.prototype.getBankBazaarUploadDocsURL = function () {
        return this.serverURL + this.uploadBankBazaarDocsURL;
    };
    /**
     * get delete NewLead Against Pan URL
     * @returns Respective API url
     */
    APIURLs.prototype.getdeletNewLeadAgainstPanURL = function () {
        return (this.serverURL.replace("/api", "/leadManagement") +
            this.deleteNewLeadAgainstPanURL);
    };
    /**
     * get Unique Check URL
     * @returns Respective API url
     */
    APIURLs.prototype.getUniqueCheckURL = function () {
        return this.serverURL + this.checkUniqueMobileEmailURL;
    };
    /**
     * Getting base url
     * @returns Respective API url
     */
    APIURLs.prototype.getBaseURL = function () {
        return this.serverURL;
        // return "https://accounts.choicebroking.in/api";
    };
    /**
     * get IPV Sms URL
     * @returns Respective API url
     */
    APIURLs.prototype.geIPVSmsURL = function () {
        return this.serverURL + this.IPVSmsURL;
    };
    /**
     * get Digio Document Upload Url
     * @returns Respective API url
     */
    APIURLs.prototype.getDigioDocUploadUrl = function () {
        return this.serverURL + this.digioDocUploadURL;
    };
    /**
     * get Digio Document Download Url
     * @param pan passing pan number
     * @param docId passing document id
     * @param formName passing form name
     * @returns Respective API url
     */
    APIURLs.prototype.getDigioDocDownloadUrl = function (pan, docId, formName) {
        return (this.serverURL +
            this.digioDocDownloadURL
                .replace("$pan", pan)
                .replace("$docId", docId)
                .replace("$formName", formName));
    };
    /**
     * Generate KYC URL
     * @returns Respective API url
     */
    APIURLs.prototype.getGenerateKYCURL = function () {
        return this.KYCBaseURL + this.generateKYCURL;
    };
    /**
     * Save KYC URL
     * @returns Respective API url
     */
    APIURLs.prototype.getSaveKYCURL = function () {
        return this.KYCBaseURL + this.saveKYCURL;
    };
    /**
     * set Environment
     * @returns environment setup
     */
    APIURLs.prototype.getEnvironment = function () {
        return this.environment;
    };
    /**
     * Send Respond OTP URL
     * @returns Respective API url
     */
    APIURLs.prototype.getSendRespondOTPURL = function () {
        return this.serverURL + this.sendRespondOTPURL;
    };
    /**
     * Verify Respond OTP URL
     * @param otp
     * @returns Respective API url
     */
    APIURLs.prototype.getVerifyRespondOTPURL = function (otp) {
        return this.serverURL + this.verifyRespondOTPURL.replace("$otp", otp);
    };
    /**
     * Referral Validation URL
     * @param referralCode
     * @returns Respective API url
     */
    APIURLs.prototype.getReferralValidationURL = function (referralCode) {
        return (this.serverURL.replace("/api", "/leadManagement") +
            this.referralCodeValidationURL.replace("$referralcode", referralCode));
    };
    /**
     * Pan Validate KYC URL
     * @returns passing API url
     */
    APIURLs.prototype.getPanValidateKYCURL = function () {
        return this.KYCBaseURL + this.panValidateKYCURL;
        // return "https://accounts.choicebroking.in/kycapi/" + this.panValidateKYCURL;
    };
    /**
     * Education List V2 URL
     * @returns Passing API url
     */
    APIURLs.prototype.getEducationListV2URL = function () {
        return this.KYCBaseURL + this.educationListV2URL;
    };
    /**
     * Client Dormant URL
     * @returns Passing API url
     */
    APIURLs.prototype.getIsClientDormantURL = function () {
        // 'https://jiffy.choiceindia.com/api/middleware2/'
        return this.JiffyMiddlewareURL + this.isClientDormantURL;
    };
    /**
     * unique check in offline url
     * @returns Passing API url
     */
    APIURLs.prototype.getUniqueCheckOfflineURL = function () {
        return this.serverURL + this.checkUniqueMobileEmailOfflineURL;
    };
    /**
   * Returns the URL for sending OTP (version 2).
   * This method provides the API endpoint for sending OTP requests.
   * @returns The URL for sending OTP requests.
   */
    APIURLs.prototype.getSendOTPV2URL = function () {
        return this.KYCBaseURL + this.sendOnboardOTPURL;
        // return 'https://accounts.choicebroking.in/kycapi/unified/send-otp'
    };
    /**
   * Returns the URL for verify OTP (version 2).
   * This method provides the API endpoint for verify OTP requests.
   * @returns The URL for sending OTP requests.
   */
    APIURLs.prototype.getVerifyOTPV2URL = function () {
        return this.KYCBaseURL + this.verifyOnboardOTPURL;
        // return "https://accounts.choicebroking.in/kycapi/unified/verify-otp"
    };
    /**
  * Returns the URL for sending OTP account closer.
  * This method provides the API endpoint for sending OTP requests.
  * @returns The URL for sending OTP requests.
  */
    APIURLs.prototype.getSendOTPACURL = function () {
        return this.KYCBaseURL + this.sendOnboardOTPURL;
        // return 'https://accounts.choicebroking.in/kycapi/unified/send-otp'
    };
    /**
 * Returns the URL for verify OTP.
 * This method provides the API endpoint for verify OTP requests.
 * @returns The URL for sending OTP requests.
 */
    APIURLs.prototype.getVerifyOTPACURL = function () {
        return this.KYCBaseURL + this.verifyOnboardOTPURL;
        // return "https://accounts.choicebroking.in/kycapi/unified/verify-otp"
    };
    /**Account Closure Details */
    APIURLs.prototype.getAccountClosureDetailsUrl = function () {
        //return this.KYCBaseURL + this.accountClosureDetails;
        return this.KYCBaseURL + this.accountClosureDetails;
    };
    /**
     * Account Closure email url
     * @param formName
     * @returns  Passing API url
     */
    APIURLs.prototype.getACEmailURL = function (formName) {
        return this.serverURL.replace("api", "kycapi") + this.sendACEmailURL;
    };
    /**
     * Adhaar masking API
     * @returns  Passing API url
     */
    APIURLs.prototype.getAdhaarMasking = function () {
        return this.KYCBaseURL + this.maskingURL;
    };
    /**
     * Getting state list API
     * @returns  Passing API url
     */
    APIURLs.prototype.getStatesListURLV2 = function () {
        return this.KYCBaseURL + this.stateListURLV2;
    };
    /**
     *  Getting lead City list API
     * @param cityname
     * @returns  Passing API url
     */
    APIURLs.prototype.getLeadCityListURLV2 = function (cityname) {
        return this.KYCBaseURL + this.cityListURLV2.replace("$cityname", cityname);
        // return  cityname? this.KYCBaseURL + this.cityListURLV2.replace('$cityname', cityname) :this.KYCBaseURL + this.cityListURLV2.replace("?cityName=$cityname", '') ;
    };
    /**
     * selfie modify url
     * @returns  Passing API url
     */
    APIURLs.prototype.getModifySelfieURL = function () {
        return this.KYCBaseURL + this.modifySelfie;
    };
    /**
     * Generate access token api
     * @returns  Passing API url
     */
    APIURLs.prototype.generateAccessTokenURL = function () {
        // return "https://accounts.choicebroking.in/kycapi/access/token";
        // return this.SSOApiURL + this.accessToken;
        return this.KYCBaseURL + this.accessToken;
    };
    /**
     * all field validation api
     * @returns  Passing API url
     */
    APIURLs.prototype.getValidationURL = function () {
        return this.KYCBaseURL + this.validationURL;
    };
    /**
     * Signature ocr API
     * @returns  Passing API url
     */
    APIURLs.prototype.getSignatureOcrURL = function () {
        return this.KYCBaseURL + this.signatureOCR;
    };
    /**
     * for document download API
     * @returns  Passing API url
     */
    APIURLs.prototype.getSecureFileDownloadURL = function () {
        return this.KYCBaseURL + this.fileDownloadURL;
    };
    /**
     * update DP preference API
     * @returns  Passing API url
     */
    APIURLs.prototype.getUpdateDPPreferenceURL = function () {
        // return "https://accounts.choicebroking.in/kycapi/update-details"
        return this.KYCBaseURL + this.updateDPPreference;
    };
    /**
     * Dp preference API
     * @param investorId passing investor Id
     * @returns Dp preference API
     */
    APIURLs.prototype.getSetterDPPreferenceURL = function (investorId) {
        // return `https://accounts.choicebroking.in/kycapi/investor-details/${investorId}`
        return this.KYCBaseURL + this.getDPPreference.replace('$investorId', investorId);
    };
    /**
     * getting all bank API
     * @returns  Passing API url
     */
    APIURLs.prototype.getAllBanksURL = function () {
        return this.KYCBaseURL + this.getAllBanks;
    };
    /**
     * Digio event log API call
     * @returns  Passing API url
     */
    APIURLs.prototype.getDigioEventsUrl = function () {
        return this.KYCBaseURL + this.digioEventsURL;
        // return 'https://accounts.choicebroking.in/kycapi/digio-event-logs' //this.KYCBaseURL + this.digioEventsURL;
    };
    /**
     * Generate modification link
     * @returns  Passing API url
     */
    APIURLs.prototype.getNewModificationLink = function () {
        return this.modificationURL + this.generateShortLink;
        // return 'https://accounts.choicebroking.in/' + this.generateShortLink
    };
    /**
     * email validation
     * @returns  Passing API url
     */
    APIURLs.prototype.getValidateEmail = function () {
        return this.KYCBaseURL + this.emailValidation;
    };
    /**
     * configure validation Id
     * @returns liveAuthEmail or uatAuthEmail value
     */
    APIURLs.prototype.getValidationId = function () {
        return '';
    };
    /** account aggregator generate link url */
    APIURLs.prototype.generateRequest = function () {
        return this.KYCBaseURL + this.generateUrl;
        // return 'https://accounts.choicebroking.in/kycapi/' + this.generateUrl
    };
    APIURLs.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function APIURLs_Factory() { return new APIURLs(); }, token: APIURLs, providedIn: "root" });
    return APIURLs;
}());
export { APIURLs };
